"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Initialize Loom i18n plugin to default language
 * @deprecate when all pugins use OuiConfiguration
 * other languages will be picked up by OuiConfiguration which will change the language
 * This part of the code should be the first thing in the barrel.
 */
var Messages_1 = require("./codegen/Messages");
var types_1 = require("./configuration/types");
function languageInit() {
    Messages_1.init(types_1.DefaultConfigurationValues.language);
}
exports.languageInit = languageInit;
//# sourceMappingURL=init.js.map